import { 
  SET_DATE
} from '../actions/date.actions'

const initState = {
  date: new Date().getTime()/1000,
  update: false
}

const dateReducer = (state = initState, action) => {
  const { type } = action
  const newState = { ...state }
  switch (type) {
    case SET_DATE:
      newState.date = action.date
    break   
    default:
      break
  }

  return newState
}

export default dateReducer
